import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'rk-form-field',
    templateUrl: './form-field.component.html',
    styleUrls: ['./form-field.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    host: { '[class.has-error]': 'showError' }
})
export class FormFieldComponent {
    @Input() showError = false;
}
